// extracted by mini-css-extract-plugin
module.exports = {"root":"Carousel_root__K0KEJ"};